import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { CreateTask } from 'components/CreateTask/CreateTask';
import { ConfirmDamage } from 'horizon/components/Damages/ConfirmDamage';
import { DeleteDamage } from 'horizon/components/Damages/DeleteDamage';
import { getPrimaryObservationGroupForDamage } from 'horizon/components/Damages/utils';
import { type AtlasGqlHorizonDamage } from 'types/atlas-graphql';
import {
  DAMAGE_CONFIRM,
  DAMAGE_DELETE,
  DAMAGE_EDIT_ATTRIBUTES,
  TASK_CREATE,
} from 'utils/access-control/rules';
import { RenderWithAccess } from 'utils/usePermissions';

import { ControlsContainer } from './ExpandedRow.style';

type ControlsProps = {
  damage: AtlasGqlHorizonDamage;
  onClickEdit: React.MouseEventHandler<HTMLElement> | undefined;
  refetchQueries?: string[];
};

export const Controls: React.FunctionComponent<ControlsProps> = ({
  damage,
  onClickEdit,
  refetchQueries,
}) => {
  const { t } = useTranslation();
  return (
    <ControlsContainer>
      <RenderWithAccess rules={[DAMAGE_EDIT_ATTRIBUTES]}>
        <Button
          data-testid="damages2-table-edit-button"
          icon={<EditOutlined />}
          onClick={onClickEdit}
        >
          {t('common.edit', 'Edit')}
        </Button>
      </RenderWithAccess>
      <RenderWithAccess rules={[DAMAGE_CONFIRM]}>
        <ConfirmDamage damage={damage} refetchQueries={refetchQueries} />
      </RenderWithAccess>
      <RenderWithAccess rules={[TASK_CREATE]}>
        <CreateTask
          horizonDamageId={damage.id}
          inspectionId={getPrimaryObservationGroupForDamage(damage)?.inspectionId}
          assetId={damage.asset?.id}
          useMenuModal
        />
      </RenderWithAccess>
      <RenderWithAccess rules={[DAMAGE_DELETE]}>
        <DeleteDamage damage={damage} refetchQueries={refetchQueries} />
      </RenderWithAccess>
    </ControlsContainer>
  );
};
